var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264 120C264 138.216 258.411 155.993 247.986 170.931C237.562 185.869 222.805 197.249 205.708 203.534C188.611 209.82 169.997 210.707 152.379 206.077C134.762 201.448 118.989 191.523 107.191 177.645C95.3925 163.766 88.137 146.601 86.4038 128.468C84.6706 110.335 88.5432 92.1068 97.4987 76.2444C106.454 60.3821 120.061 47.6497 136.483 39.7663C152.905 31.883 171.35 29.2284 189.328 32.1609L175 120H264Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140.5,
    cy: 81.5,
    r: 11.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.5,
    cy: 149.5,
    r: 11.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 165.5,
    r: 11.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPalette);
export default __webpack_public_path__ + "static/media/colorPalette.f8f4f3900678e1028570863baf41f188.svg";
export { ForwardRef as ReactComponent };